import { render, staticRenderFns } from "./dashboard.vue?vue&type=template&id=55dac1af&scoped=true&"
import script from "./dashboard.vue?vue&type=script&lang=ts&"
export * from "./dashboard.vue?vue&type=script&lang=ts&"
import style0 from "./dashboard.vue?vue&type=style&index=0&id=55dac1af&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55dac1af",
  null
  
)

export default component.exports